// extracted by mini-css-extract-plugin
export default {"modalOverlay":"PL-z","modalContent":"QL-z","header":"RL-z","close":"SL-z"};